import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getList({ searchParams, printMode }) {
		try {
			const queryStr = objectToQueryString({
				pmcNo: searchParams.pmcNo,
				ipnNos: searchParams.ipnNos,
				custCd: searchParams.custCd,
				cpnyScn: searchParams.cpnyScn,
				saveStatus: searchParams.saveStatus
			});
			const addQueryStr = searchParams.changeCustCd ? '&changeCustCd=Y' : '';
			const printModeStr = printMode ? '&printMode=Y' : '';
			const response = await client.get(`${BASE_URL}/pqy/fcku/fwdCkuTest/v1/lists${queryStr}${addQueryStr}${printModeStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	/**한번에 공통 코드 부르기 */
	async getCommCodesOnce() {
		try {
			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/fwdCkuTestCustCodeLists`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getPmcList({ params, currentPage, pageUnit }) {
		try {
			const queryStr = objectToQueryString({
				strDt: params.strDt,
				endDt: params.endDt,
				pprrId: params.pprrId,
				pmcNo1: params.pmcNo1,
				currentPage,
				pageUnit
			});
			const response = await client.get(`${BASE_URL}/pqy/fcku/fwdCkuTest/v1/pmcs${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getPartCkuList({ params, currentPage, pageUnit }) {
		try {
			const queryStr = objectToQueryString({
				strDt: params.strDt,
				endDt: params.endDt,
				partNo: params.partNo,
				ovrlJgmtCd: params.ovrlJgmtCd,
				currentPage,
				pageUnit
			});
			const response = await client.get(`${BASE_URL}/pqy/fcku/fwdCkuTest/v1/ckus${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async saveData(params) {
		try {
			const pathVariables = `pmcNo/${params.get('pmcNo')}`;
			const response = await client.post(`${BASE_URL}/pqy/fcku/fwdCkuTest/v1/status/1/${pathVariables}`, params, {
				headers: { 'Content-Type': 'multipart/form-data' }
			});
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async updateImg(params) {
		try {
			const pathVariables = `pmcNo/${params.get('pmcNo')}/ipnNos/${params.get('ipnNos')}/fwdImg`;
			const response = await client.post(`${BASE_URL}/pqy/fcku/fwdCkuTest/v1/status/2/${pathVariables}`, params, {
				headers: { 'Content-Type': 'multipart/form-data' }
			});
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async updateOputSt(params) {
		try {
			const pathVariables = `pmcNo/${params.pmcNo}/ipnNos/${params.ipnNos}/oputSt`;
			const response = await client.post(`${BASE_URL}/pqy/fcku/fwdCkuTest/v1/status/2/${pathVariables}`, params);
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async updateCustCd(params) {
		try {
			const pathVariables = `pmcNo/${params.pmcNo}/ipnNos/${params.ipnNos}/custCd`;
			const response = await client.post(`${BASE_URL}/pqy/fcku/fwdCkuTest/v1/status/2/${pathVariables}`, params);
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async fileDownload(params) {
		// 이미지 미리보기와 실제파일 다운로드에서 같이 사용하기 때문에 주의할것
		try {
			const response = await client.post(`${BASE_URL}/uploadForm/v1/downloadFile`, params, { responseType: 'blob' });
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
